import { Link } from "react-router-dom";
import ModalBase from "./ModalBase";
import { useModal } from "../../js/hooks/useModal";
import { pricingUrl, JOURNEY_LINK_PROPS } from "../../js/utils/siteLinks";

export default function GuestLockModal() {
  const modal = useModal("guestLock");

  return (
    <ModalBase
      isOpen={modal.isOpen}
      title="Preview Only"
      onClose={modal.close}
      welcome
      wide
      className="modal-guest-lock"
    >
      <div className="guest-lock-modal">
        <p className="guest-lock-modal__eyebrow">Guest access</p>
        <p className="guest-lock-modal__lead">
          You&apos;re welcome to explore the structure of the journey — fields stay locked until you
          sign in or your agent invites you.
        </p>
        <div className="guest-lock-modal__rule" aria-hidden="true" />
        <p className="guest-lock-modal__message">
          Talk to your Agent or Broker about REChecklist. If they&apos;re not already using it, ask
          them to take a look — they can start offering clients like you a better experience today.
        </p>
        <div className="guest-lock-modal__actions">
          <Link className="guest-lock-modal__cta guest-lock-modal__cta--primary" to="/login" onClick={modal.close}>
            Sign in
          </Link>
          <a
            className="guest-lock-modal__cta guest-lock-modal__cta--secondary"
            href={pricingUrl()}
            onClick={modal.close}
            {...JOURNEY_LINK_PROPS}
          >
            View plans for professionals
          </a>
        </div>
      </div>
    </ModalBase>
  );
}
